import React, { useEffect, useState } from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';
const EmailStatistics = ({ count, name, title, icon }) => {
  const iconClass = icon && icon.trim() !== "" ? icon : "iconsminds-finger-print";
  return (
    <div className="mb-4 col-sm-12 col-lg-6 col-xl-6">
      <div className="card">
        <div className="text-center card-body">
          <i className={iconClass}></i>
          <p
            className="card-text font-weight-semibold mb-0"
            style={{ lineHeight: '17px' }}
          >
            <IntlMessages id={title} />
          </p>
          <p className="lead text-center" style={{ fontSize: '1.2rem' }}>
            {count} <IntlMessages id={name} />
          </p>
        </div>
      </div>
    </div>
  );
};
export default EmailStatistics;
